<template>
    <div style="margin-bottom:80px;">
        <div v-if="!noItemsMessage" class="total-section bg-surface-variant">
            <span>購入額合計</span>
            <span>{{ addComma(totalPrice) }}円</span>
        </div>
        <v-container>
            <template v-for="item in cartItemList" :key="item.ec_item_id">
                <v-row class="mb-5 mx-0 pa-3 border bg-white rounded-lg">
                    <v-col cols="12" class="pa-0 mb-3">
                        <router-link
                            :to="{ name: 'ecItemContent', query: { ecitem_id: item.ec_item_id, title: item.item_name } }"
                            class="text-decoration-none ecitem-name">
                            {{ item.item_name }}
                        </router-link>
                    </v-col>
                    <v-col cols="auto" class="ecitem-tile__thumbnail ecitem-tile__thumbnail--default pa-0">
                        <div class="ecitem-tile-thumbnail__cover"
                            :style="{ backgroundImage: `url(/data/ec/${item.ec_item_id}/main.jpg)` }"></div>
                    </v-col>
                    <v-col class="ecitem-tile__body ecitem-tile-body pa-0 pl-3">
                        <div class="ecitem-tile-body__detail">
                            <span class="gray">単価</span>
                            <span>{{ addComma(item.price) }}円</span>
                        </div>
                        <div class="ecitem-tile-body__detail">
                            <span class="gray">個数</span>
                            <span class="modItem-content">
                                <v-btn @click="modItem(item.ec_item_id, parseInt(item.ec_item_count) - 1)" color="tertiary" variant="flat"
                                    class="mr-3 modItem-btn" density="compact" size="small" icon="mdi-minus"></v-btn>
                                {{ item.ec_item_count }}個
                                <v-btn @click="modItem(item.ec_item_id, parseInt(item.ec_item_count) + 1)" color="tertiary" variant="flat"
                                    class="ml-3 modItem-btn" density="compact" size="small" icon="mdi-plus"></v-btn>
                            </span>
                        </div>
                        <div class="ecitem-tile-body__detail">
                            <span class="gray">小計</span>
                            <span>{{ addComma(item.price * item.ec_item_count) }}円</span>
                        </div>
                        <div class="text-right">
                            <button @click="deleteItem(item.ec_item_id)" class="del-button">削除する</button>
                        </div>
                    </v-col>
                </v-row>
            </template>
            <div class="mt-10" v-if="togetherItem && viewTogetherItem && !noItemsMessage">
                <h2>以下の商品も一緒に購入されています</h2>
                <StoreMainTile :ec_item_id="togetherItem.ec_item_id" :ec_item_name="togetherItem.item_name"
                    :description="togetherItem.explanation_short" :price="togetherItem.price"
                    :thumbnail="`background-image: url('/data/ec/${togetherItem.ec_item_id}/main.jpg')`" />
            </div>
            <div v-if="!noItemsMessage" class="form__button_area">
                <v-btn color="primary" @click="gotoform" block class="rounded-pill" size="large">購入手続きに進む</v-btn>
            </div>
            <div v-if="noItemsMessage" class="text-center my-10">{{ noItemsMessage }}</div>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios';
import Helper from '../assets/js/helper';
import StoreMainTile from '../components/StoreMainTile.vue';

export default {
    name: 'CartList',
    components: {
        StoreMainTile
    },
    data: () => ({
        cartItemList: [],
        upperList: [],
        noItemsMessage: '',
        totalPrice: 0,
        lockUpdate: false,
        togetherItem: [],
        viewTogetherItem: false
    }),
    mounted() {
        this.getCartItemList();
    },
    computed: {
        numberItemsInCart: {
            get() {
                return this.$store.getters.numberItemsInCart
            },
            set(value) {
                this.$store.dispatch("setNumberItemsInCart", value);
            }
        },
        flushMessage: {
            set(value) {
                this.$store.dispatch("setFlushMessage", value);
            }
        }
    },
    created() { },
    watch: {
        '$route': 'getCartItemList',
    },
    methods: {
        async getCartItemList() {
            const response = await axios.get('/api/cart/list');
            this.cartItemList = response.data;
            if (this.cartItemList.length == 0) {
                this.noItemsMessage = 'カートに商品がありません。';
            } else {
                this.cartItemList.forEach((item) => {
                    this.upperList[item.ec_item_id] = (item.upper_limit_suryo) ? item.upper_limit_suryo : 100;
                });
                this.noItemsMessage = '';
                this.calcTotalPrice();

                //同時購入されている商品（カートの一番最後の商品）
                const res2 = await axios.get('/api/ec/together', {
                    params: {
                        item_id: this.cartItemList[this.cartItemList.length - 1].ec_item_id
                    }
                }).catch(() => {
                    return;
                });
                this.togetherItem = res2.data;
                this.$nextTick(() => {
                    this.viewTogetherItem = true;
                });
            }
        },
        async deleteItem(itemId) {
            if (this.lockUpdate) {
                return;
            }
            this.lockUpdate = true;

            const response = await axios.get('/api/cart/delete?item_id=' + itemId);
            this.cartItemList = response.data;
            this.numberItemsInCart = this.cartItemList.length;
            if (this.cartItemList.length == 0) {
                this.noItemsMessage = 'カートに商品がありません。';
                this.togetherItem = [];
            } else {
                this.noItemsMessage = '';
                this.calcTotalPrice();
            }

            this.lockUpdate = false;

            this.flushMessage = 'カートから削除しました。';

        },
        async modItem(itemId, count) {
            if (this.lockUpdate) {
                console.log('個数変更をロック中');
                return;
            }
            if (count < 1) {
                this.flushMessage = '個数は1以上で指定してください。';
                return;
            }
            if (this.upperList[itemId] < count) {
                this.flushMessage = 'これ以上の個数は購入できません。';
                return;
            }
            this.lockUpdate = true;
            const response = await axios.get('/api/cart/mod?item_id=' + itemId + '&suryo=' + count).catch((error) => {
                this.flushMessage = 'これ以上の個数は購入できません。';
                console.log(error);
                return;
            })
            this.cartItemList = response.data;
            this.calcTotalPrice();
            this.lockUpdate = false;
        },
        addComma(value) {
            return Helper.addComma(value);
        },
        calcTotalPrice() {
            this.totalPrice = this.cartItemList.reduce((sum, item) => sum + item.price * item.ec_item_count, 0);
        },
        gotoform() {
            location.href = '/store/order/form?utm_source=webapp&utm_medium=referral&utm_campaign=order_form';
        }
    }
}
</script>

<style scoped>
.total-section {
    display: flex;
    justify-content: space-between;
    padding: 20px 25px;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
}

.ecitem-tile__thumbnail {
    width: 112px;
    height: fit-content;
    aspect-ratio: 1;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    overflow: hidden;
    border-radius: 8px;
    background-color: transparent;
}

.ecitem-tile__thumbnail--default {
    background-image: url('../assets/images/empty.gif');
}

.ecitem-tile-thumbnail__cover {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    aspect-ratio: 1;
}

.ecitem-tile__body {
    width: calc(100% - 25%);
}

.ecitem-tile-body {
    display: flex;
    flex-flow: column;
    text-align: left;
    justify-content: space-between;
}

.ecitem-tile-body__detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 5px;
    margin-bottom: 5px;
}

.ecitem-tile-body__detail:last-child {
    border-bottom: none;
}

.del-button {
    color: #aaa;
    font-size: 10px;
}

.del-button:hover {
    text-decoration: underline;
}

.form__button_area {
    position: fixed;
    padding: 10px;
    bottom: 80px;
    left: 0;
    width: 100%;
    z-index: 2;
}

.ecitem-name {
    font-size: 0.9em;
}

.gray {
    color: #888;
    font-size: 12px;
}

.modItem-content {
    font-size: 20px;
    display: flex;
    align-items: center;
}

.modItem-btn {
    width: 18px;
    height: 18px;
}
</style>